var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leg",style:({bottom: _vm.bottomNum + 'px'})},_vm._l((_vm.legendList),function(item,i){return _c('div',{key:i,class:`leg-item index${i}`},[_c('img',{attrs:{"src":item.img,"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }